export default {
  routes: [
    {
      name: 'counterparties',
      path: '/directory/counterparty',
      component: () => import('./views/TheCounterparties.vue'),

    },

    {
      name: 'counterparty',
      path: '/directory/counterparty/:uuid',
      component: () => import('./views/TheCounterparty.vue'),
    },
  ]
}
